<form *ngIf="filters.length" [formGroup]="formSearch" novalidate>
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
            RECHERCHE
        </mat-expansion-panel-header>

        <vedrax-form-control *ngFor="let descriptor of filters" [form]="formSearch" [descriptor]="descriptor">
            </vedrax-form-control>

        <mat-action-row>
            <button type="button" mat-raised-button (click)="reset()">EFFACER</button>
            <button type="button" [disabled]="formSearch.invalid || submitted" mat-raised-button color="primary" (click)="submit(formSearch.value)">SOUMETTRE</button>
        </mat-action-row>
    </mat-expansion-panel>
</form>